import CityPage from "../CityPage";
import { citiesData } from "@/mocks/cities";

export default function CityVersaillesPage() {
  const data = citiesData.find((c) => c.slug === "versailles")!;
  return <CityPage data={data} />;
}
